import type { SVGProps } from 'react';
import React from 'react';

export interface IProps extends SVGProps<SVGSVGElement> {
  color?: 'red' | 'blue';
}

export const Logo: React.FC<IProps> = ({ color, ...rest }) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" {...rest}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-117.000000, -17.000000)">
        <g>
          <g transform="translate(111.000000, 0.000000)">
            <path
              d="M27.9482285,40.7999976 C29.7472636,40.7999976 30.2509934,39.5158513 29.8911864,38.374388 C29.459418,37.0902417 26.0772319,27.3164618 26.0772319,27.3164618 C26.0772319,27.3164618 22.6230845,37.6609734 22.1913161,38.9451196 C21.471702,41.0853634 18.449323,40.3006074 19.1689371,37.9463392 C19.8885511,35.592071 24.134274,22.3225596 24.7099652,20.6817061 C25.4295793,18.5414623 26.3650775,17.5426819 28.5239197,17.399999 L17.9455932,17.399999 C16.0745967,17.399999 14.7792914,18.6841452 14.347523,20.1823159 C13.9157545,21.6804865 9.16630181,36.2341442 8.73453338,37.6609734 C8.15884214,39.3731684 7.07942107,40.3719488 6,40.7286561 C7.5831509,40.7999976 27.9482285,40.7999976 27.9482285,40.7999976"
              fill={!color || color === 'red' ? '#FF0000' : '#1e3d5a'}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
